// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Grid Layout */
.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

/* Media Card */
.media-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  background-color: rgba(17, 24, 39, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.media-card:hover {
  transform: translateY(-12px);
  background-color: rgba(17, 24, 39, 1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
}

/* Featured Image Animation */
.media-image-container {
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.media-image {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  height: 100%;
  display: block;
}

.media-card:hover .media-image {
  transform: scale(1.05);
}

/* Title Animation */
.media-title {
  transition: color 0.3s ease;
  color: #ffffff;
}

.media-card:hover .media-title {
  color: #60a5fa;
}

/* Author Image */
.author-image {
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.media-card:hover .author-image {
  border-color: #2563eb;
}

/* Category Badge Animation */
.category-badge {
  animation: slideInRight 0.3s ease;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .media-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .media-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Tablet: 2-column layout */
@media (min-width: 640px) and (max-width: 1024px) {
  .media-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Desktop: 3-column layout */
@media (min-width: 1025px) {
  .media-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Line clamp for text truncation */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Button animations */
.media-card button:hover {
  animation: slideRight 0.3s ease;
}

@keyframes slideRight {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(4px);
  }
  100% {
    transform: translateX(0);
  }
}

/* Loading spinner */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/MediaSection.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iDAAiD;EACjD,eAAe;EACf,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;IAC5D,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Media Grid Layout */\n.media-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n/* Media Card */\n.media-card {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  background-color: rgba(17, 24, 39, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.media-card:hover {\n  transform: translateY(-12px);\n  background-color: rgba(17, 24, 39, 1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n}\n\n/* Featured Image Animation */\n.media-image-container {\n  position: relative;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n.media-image {\n  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.media-card:hover .media-image {\n  transform: scale(1.05);\n}\n\n/* Title Animation */\n.media-title {\n  transition: color 0.3s ease;\n  color: #ffffff;\n}\n\n.media-card:hover .media-title {\n  color: #60a5fa;\n}\n\n/* Author Image */\n.author-image {\n  border: 2px solid transparent;\n  transition: border-color 0.3s ease;\n}\n\n.media-card:hover .author-image {\n  border-color: #2563eb;\n}\n\n/* Category Badge Animation */\n.category-badge {\n  animation: slideInRight 0.3s ease;\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .media-grid {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .media-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* Tablet: 2-column layout */\n@media (min-width: 640px) and (max-width: 1024px) {\n  .media-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Desktop: 3-column layout */\n@media (min-width: 1025px) {\n  .media-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Line clamp for text truncation */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.line-clamp-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Button animations */\n.media-card button:hover {\n  animation: slideRight 0.3s ease;\n}\n\n@keyframes slideRight {\n  0% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(4px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n/* Loading spinner */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
